"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 5.4a6.6 6.6 0 100 13.2 6.6 6.6 0 000-13.2zm-.943 11.654a5.142 5.142 0 01-4.17-5.59L9.71 14.31v.679c0 .746.606 1.358 1.347 1.358v.707zm4.783-1.637a1.307 1.307 0 00-1.2-.777h-.66v-1.98a.662.662 0 00-.66-.66H9.36v-1.32h1.32c.363 0 .66-.297.66-.66V8.7h1.32c.726 0 1.32-.594 1.32-1.32v-.125a5.142 5.142 0 011.86 8.162z" }), "Web");
//# sourceMappingURL=Web.js.map